export const siteConfig = {
  name: '撸撸社',
  tagline: '发现热爱，连接同好',
  description: '撸撸社是一个专注于兴趣爱好交流的社区平台，汇聚同好、分享经验、互动娱乐。加入撸撸社，发现更多有趣内容，结交志同道合的朋友，享受轻松愉快的社群氛围。',
  url: 'https://lulushe.com',
  foundingYear: 2023,
  memberCount: 1280000,
  articleCount: 56800,
  categoryCount: 12,
  dailyActive: 86000,
};

export const categories = [
  {
    slug: 'shougong',
    name: '手工DIY',
    icon: 'ri-scissors-cut-line',
    description: '分享手工制作教程和创意作品，从编织到木工，用双手创造美好',
    color: 'primary',
    articleCount: 4820,
    imageUrl: 'https://readdy.ai/api/search-image?query=Creative%20handmade%20DIY%20crafts%20workspace%20with%20colorful%20yarn%20fabric%20and%20tools%20on%20wooden%20table%2C%20warm%20natural%20lighting%2C%20cozy%20creative%20atmosphere%2C%20soft%20focus%20background%2C%20artistic%20lifestyle%20photography&width=400&height=260&seq=category-shougong&orientation=landscape',
  },
  {
    slug: 'sheying',
    name: '摄影艺术',
    icon: 'ri-camera-line',
    description: '摄影技巧、器材评测、作品分享，用镜头记录生活中的美好瞬间',
    color: 'accent',
    articleCount: 6350,
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20film%20camera%20on%20wooden%20desk%20with%20scattered%20photographs%20and%20warm%20sunlight%20streaming%20through%20window%2C%20nostalgic%20creative%20studio%20atmosphere%2C%20soft%20shadows%2C%20artistic%20photography%20aesthetic&width=400&height=260&seq=category-sheying&orientation=landscape',
  },
  {
    slug: 'meishi',
    name: '美食烹饪',
    icon: 'ri-restaurant-line',
    description: '家常菜谱、烘焙甜品、探店分享，用美食温暖生活的每一天',
    color: 'primary',
    articleCount: 7820,
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20home%20cooked%20meal%20on%20rustic%20wooden%20table%20with%20fresh%20ingredients%20herbs%20and%20warm%20kitchen%20lighting%2C%20cozy%20culinary%20scene%2C%20soft%20natural%20light%2C%20food%20photography%20aesthetic&width=400&height=260&seq=category-meishi&orientation=landscape',
  },
  {
    slug: 'yundong',
    name: '运动健身',
    icon: 'ri-run-line',
    description: '跑步、瑜伽、球类运动，科学健身方法，遇见更好的自己',
    color: 'secondary',
    articleCount: 5410,
    imageUrl: 'https://readdy.ai/api/search-image?query=Morning%20jogging%20scene%20in%20peaceful%20park%20with%20soft%20golden%20sunlight%20through%20trees%2C%20fitness%20lifestyle%20atmosphere%2C%20healthy%20active%20living%2C%20warm%20natural%20tones%2C%20serene%20outdoor%20photography&width=400&height=260&seq=category-yundong&orientation=landscape',
  },
  {
    slug: 'yuedu',
    name: '阅读写作',
    icon: 'ri-book-open-line',
    description: '好书推荐、读书笔记、原创写作，在文字的世界里自由翱翔',
    color: 'accent',
    articleCount: 3980,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20stacked%20books%20warm%20lamp%20light%20and%20soft%20blanket%20on%20armchair%2C%20peaceful%20library%20atmosphere%2C%20gentle%20natural%20light%2C%20literary%20lifestyle%20photography%20with%20warm%20neutral%20tones&width=400&height=260&seq=category-yuedu&orientation=landscape',
  },
  {
    slug: 'youxi',
    name: '游戏电竞',
    icon: 'ri-gamepad-line',
    description: '游戏攻略、电竞赛事、玩家交流，在虚拟世界中并肩作战',
    color: 'primary',
    articleCount: 9230,
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20gaming%20setup%20with%20mechanical%20keyboard%20and%20warm%20ambient%20LED%20lighting%2C%20cozy%20gaming%20room%20atmosphere%2C%20clean%20desk%20setup%2C%20soft%20focus%20background%2C%20tech%20lifestyle%20photography&width=400&height=260&seq=category-youxi&orientation=landscape',
  },
  {
    slug: 'lvxing',
    name: '旅行探索',
    icon: 'ri-earth-line',
    description: '旅行攻略、户外探险、城市漫步，世界那么大一起去看看',
    color: 'secondary',
    articleCount: 4560,
    imageUrl: 'https://readdy.ai/api/search-image?query=Scenic%20mountain%20landscape%20with%20hiking%20trail%20and%20warm%20golden%20hour%20sunlight%2C%20adventure%20travel%20atmosphere%2C%20natural%20warm%20earth%20tones%2C%20peaceful%20outdoor%20exploration%20photography%20with%20soft%20atmospheric%20haze&width=400&height=260&seq=category-lvxing&orientation=landscape',
  },
  {
    slug: 'yinyue',
    name: '音乐之声',
    icon: 'ri-music-line',
    description: '乐器学习、音乐分享、演出资讯，让旋律点亮生活的节奏',
    color: 'accent',
    articleCount: 3670,
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20acoustic%20guitar%20leaning%20against%20wooden%20chair%20with%20warm%20sunlight%20and%20sheet%20music%20scattered%2C%20cozy%20music%20room%20atmosphere%2C%20soft%20natural%20lighting%2C%20artistic%20music%20lifestyle%20photography&width=400&height=260&seq=category-yinyue&orientation=landscape',
  },
];

export const featuredArticles = [
  {
    id: 1,
    title: '零基础也能学会的手工编织入门指南',
    excerpt: '从选材到起针，手把手教你编织出第一件温暖的小围巾，手工的快乐从一根线开始。',
    category: '手工DIY',
    categorySlug: 'shougong',
    author: '巧手小鹿',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20deer%20avatar%20with%20warm%20orange%20tones%20flat%20illustration%20style%20simple%20and%20friendly&width=100&height=100&seq=avatar-01&orientation=squarish',
    readTime: 8,
    likes: 2340,
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20colorful%20yarn%20and%20knitting%20needles%20on%20warm%20wooden%20table%20with%20gentle%20sunlight%2C%20cozy%20handmade%20craft%20atmosphere%2C%20warm%20neutral%20tones%2C%20lifestyle%20photography&width=600&height=400&seq=article-card-1&orientation=landscape',
    date: '2026-08-08',
    isHot: true,
  },
  {
    id: 2,
    title: '手机摄影进阶：10个让你照片质感翻倍的小技巧',
    excerpt: '不买相机也能拍出大片感！掌握构图、光影和后期这三板斧，你的朋友圈照片从此与众不同。',
    category: '摄影艺术',
    categorySlug: 'sheying',
    author: '光影捕手',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20camera%20avatar%20with%20warm%20teal%20tones%20flat%20illustration%20style%20simple%20and%20friendly&width=100&height=100&seq=avatar-02&orientation=squarish',
    readTime: 12,
    likes: 3150,
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20photography%20setup%20on%20minimal%20wooden%20desk%20with%20soft%20natural%20light%20and%20scattered%20photos%2C%20creative%20modern%20atmosphere%2C%20warm%20neutral%20tones%2C%20artistic%20photography&width=600&height=400&seq=article-card-2&orientation=landscape',
    date: '2026-08-07',
    isHot: true,
  },
  {
    id: 3,
    title: '在家复刻网红甜品：零失败的提拉米苏做法',
    excerpt: '不用烤箱、不用打蛋器，简单几步就能做出入口即化的经典提拉米苏，朋友来家做客的最佳选择。',
    category: '美食烹饪',
    categorySlug: 'meishi',
    author: '厨房小当家',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20chef%20hat%20avatar%20with%20warm%20coral%20tones%20flat%20illustration%20style%20simple%20and%20friendly&width=100&height=100&seq=avatar-03&orientation=squarish',
    readTime: 10,
    likes: 4890,
    imageUrl: 'https://readdy.ai/api/search-image?query=Homemade%20tiramisu%20in%20elegant%20glass%20dish%20with%20cocoa%20powder%20dusting%20on%20rustic%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20cozy%20cooking%20atmosphere%2C%20food%20photography&width=600&height=400&seq=article-card-3&orientation=landscape',
    date: '2026-08-06',
    isHot: true,
  },
  {
    id: 4,
    title: '晨跑vs夜跑：哪种更适合你的生活节奏？',
    excerpt: '从生物钟、空气质量到安全性，全方位对比早晚跑步的利与弊，帮你找到最适合的跑步时间。',
    category: '运动健身',
    categorySlug: 'yundong',
    author: '跑者阿飞',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20runner%20avatar%20with%20warm%20amber%20tones%20flat%20illustration%20style%20simple%20and%20friendly&width=100&height=100&seq=avatar-04&orientation=squarish',
    readTime: 9,
    likes: 1980,
    imageUrl: 'https://readdy.ai/api/search-image?query=Peaceful%20park%20running%20path%20at%20sunrise%20with%20golden%20morning%20light%20through%20trees%2C%20fitness%20lifestyle%20scene%2C%20warm%20natural%20atmosphere%2C%20serene%20outdoor%20photography&width=600&height=400&seq=article-card-4&orientation=landscape',
    date: '2026-08-05',
    isHot: false,
  },
  {
    id: 5,
    title: '2026年必读书单：这12本书改变了我的人生观',
    excerpt: '从文学经典到社科新知，精选12本年度最佳读物。每本书都值得你花时间细细品读，收获远超想象。',
    category: '阅读写作',
    categorySlug: 'yuedu',
    author: '书虫小姐',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20bookworm%20avatar%20with%20warm%20teal%20tones%20flat%20illustration%20style%20simple%20and%20friendly&width=100&height=100&seq=avatar-05&orientation=squarish',
    readTime: 15,
    likes: 2760,
    imageUrl: 'https://readdy.ai/api/search-image?query=Stack%20of%20beautiful%20books%20on%20cozy%20wooden%20desk%20with%20warm%20reading%20lamp%20light%20and%20coffee%20cup%2C%20peaceful%20reading%20atmosphere%2C%20soft%20natural%20light%2C%20literary%20lifestyle%20photography&width=600&height=400&seq=article-card-5&orientation=landscape',
    date: '2026-08-04',
    isHot: false,
  },
  {
    id: 6,
    title: '从青铜到王者：新赛季最全面的英雄攻略合集',
    excerpt: '最新版本强势英雄深度解析，出装、铭文、打法一网打尽，助你在排位赛中快速上分！',
    category: '游戏电竞',
    categorySlug: 'youxi',
    author: '电竞老司机',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20gamer%20avatar%20with%20warm%20coral%20tones%20flat%20illustration%20style%20simple%20and%20friendly&width=100&height=100&seq=avatar-06&orientation=squarish',
    readTime: 18,
    likes: 6230,
    imageUrl: 'https://readdy.ai/api/search-image?query=Gaming%20setup%20with%20RGB%20keyboard%20and%20mouse%20on%20dark%20desk%20with%20warm%20ambient%20lighting%2C%20modern%20esports%20atmosphere%2C%20clean%20tech%20lifestyle%20photography%20with%20soft%20glow&width=600&height=400&seq=article-card-6&orientation=landscape',
    date: '2026-08-03',
    isHot: true,
  },
];

export const categoryArticles: Record<string, Array<{
  id: number;
  title: string;
  excerpt: string;
  author: string;
  authorAvatar: string;
  readTime: number;
  likes: number;
  date: string;
  imageUrl: string;
  isHot: boolean;
}>> = {
  shougong: [
    { id: 101, title: '零基础手工编织入门：从选材到完成第一件作品', excerpt: '编织是最治愈的手工活动之一，这篇文章带你从零开始，选择适合的毛线和钩针，完成一条温暖的手工围巾。', author: '巧手小鹿', authorAvatar: 'https://readdy.ai/api/search-image?width=100&height=100&seq=avatar-01&orientation=squarish&query=Cute%20cartoon%20deer%20avatar%20with%20warm%20orange%20tones%20flat%20illustration%20style', readTime: 8, likes: 2340, date: '2026-08-08', imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20colorful%20yarn%20and%20knitting%20needles%20on%20warm%20wooden%20table%2C%20cozy%20handmade%20craft%20atmosphere&width=600&height=400&seq=article-shougong-101&orientation=landscape', isHot: true },
    { id: 102, title: '废旧衣物大改造：创意DIY让旧衣焕发新生', excerpt: '家里堆了很多不穿的旧衣服？别急着扔！教你几种简单的改造方法，变废为宝，环保又有趣。', author: '改造达人', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20artist%20avatar%20with%20warm%20coral%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-07&orientation=squarish', readTime: 6, likes: 1560, date: '2026-08-06', imageUrl: 'https://readdy.ai/api/search-image?query=Upcycled%20clothing%20DIY%20project%20on%20wooden%20table%20with%20scissors%20and%20fabric%2C%20creative%20craft%20atmosphere&width=600&height=400&seq=article-shougong-102&orientation=landscape', isHot: false },
    { id: 103, title: '入门木工必备工具清单：预算100元就能开始', excerpt: '木工不需要昂贵设备，100元预算就能开启你的木工之旅。从锯子到砂纸，看看都需要哪些基础工具。', author: '木头先生', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20carpenter%20avatar%20with%20warm%20amber%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-08&orientation=squarish', readTime: 7, likes: 1890, date: '2026-08-03', imageUrl: 'https://readdy.ai/api/search-image?query=Basic%20woodworking%20tools%20on%20rustic%20wooden%20workbench%20with%20warm%20workshop%20lighting&width=600&height=400&seq=article-shougong-103&orientation=landscape', isHot: false },
    { id: 104, title: '折纸艺术入门：从千纸鹤到复杂立体造型', excerpt: '一张纸能玩出多少花样？从最经典的千纸鹤开始，逐步挑战更有趣的折纸造型，锻炼耐心和手眼协调。', author: '纸艺大师', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20origami%20avatar%20with%20warm%20teal%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-09&orientation=squarish', readTime: 5, likes: 1230, date: '2026-07-28', imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20origami%20paper%20cranes%20on%20minimal%20white%20desk%20with%20warm%20natural%20light&width=600&height=400&seq=article-shougong-104&orientation=landscape', isHot: false },
  ],
  sheying: [
    { id: 201, title: '手机摄影进阶：10个让你照片质感翻倍的小技巧', excerpt: '不买相机也能拍出大片感！掌握构图、光影和后期这三板斧，你的朋友圈照片从此与众不同。', author: '光影捕手', authorAvatar: 'https://readdy.ai/api/search-image?width=100&height=100&seq=avatar-02&orientation=squarish&query=Cute%20cartoon%20camera%20avatar%20with%20warm%20teal%20tones%20flat%20illustration%20style', readTime: 12, likes: 3150, date: '2026-08-07', imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20photography%20setup%20on%20minimal%20wooden%20desk%20with%20soft%20natural%20light&width=600&height=400&seq=article-sheying-201&orientation=landscape', isHot: true },
    { id: 202, title: '黄金时刻拍摄指南：如何利用日出日落拍出绝美照片', excerpt: '摄影的魔法时刻就在日出后和日落前的黄金一小时，掌握这些技巧，让你的照片充满温暖的金色光芒。', author: '追光者', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20sun%20avatar%20with%20warm%20amber%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-10&orientation=squarish', readTime: 10, likes: 2450, date: '2026-08-05', imageUrl: 'https://readdy.ai/api/search-image?query=Golden%20hour%20landscape%20photography%20scene%20with%20warm%20sunset%20light%20over%20mountains&width=600&height=400&seq=article-sheying-202&orientation=landscape', isHot: false },
    { id: 203, title: '入门相机选购指南：2026年最值得推荐的5款微单', excerpt: '想买相机但不知道从何选起？从预算、需求到品牌，帮你梳理选购思路，找到最适合你的第一台相机。', author: '器材控', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20tech%20avatar%20with%20warm%20coral%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-11&orientation=squarish', readTime: 14, likes: 2980, date: '2026-08-01', imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20mirrorless%20camera%20on%20wooden%20desk%20with%20warm%20natural%20light%20and%20clean%20aesthetic&width=600&height=400&seq=article-sheying-203&orientation=landscape', isHot: false },
  ],
  meishi: [
    { id: 301, title: '在家复刻网红甜品：零失败的提拉米苏做法', excerpt: '不用烤箱、不用打蛋器，简单几步就能做出入口即化的经典提拉米苏，朋友来家做客的最佳选择。', author: '厨房小当家', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20chef%20avatar%20with%20warm%20coral%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-03&orientation=squarish', readTime: 10, likes: 4890, date: '2026-08-06', imageUrl: 'https://readdy.ai/api/search-image?query=Homemade%20tiramisu%20in%20elegant%20glass%20dish%20with%20cocoa%20powder%20on%20rustic%20table&width=600&height=400&seq=article-meishi-301&orientation=landscape', isHot: true },
    { id: 302, title: '一周减脂餐食谱：好吃不胖的健康美食合集', excerpt: '减肥不用饿肚子！分享七天不重样的减脂餐搭配，低卡又美味，让你吃得开心瘦得健康。', author: '营养师小王', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20nutritionist%20avatar%20with%20warm%20green%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-12&orientation=squarish', readTime: 12, likes: 5670, date: '2026-08-04', imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20healthy%20meal%20bowl%20on%20minimal%20wooden%20table%20with%20fresh%20vegetables%20and%20warm%20light&width=600&height=400&seq=article-meishi-302&orientation=landscape', isHot: false },
    { id: 303, title: '家常菜也能高大上：5道让客人惊艳的宴客菜', excerpt: '不需要去餐厅花大钱，在家就能做出堪比大厨的精致菜肴。分享5道好看又好吃的宴客菜做法。', author: '美食达人', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20foodie%20avatar%20with%20warm%20orange%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-13&orientation=squarish', readTime: 15, likes: 3420, date: '2026-07-30', imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20home%20cooked%20Chinese%20dishes%20on%20beautiful%20ceramic%20plates%20with%20warm%20dining%20atmosphere&width=600&height=400&seq=article-meishi-303&orientation=landscape', isHot: false },
  ],
  yundong: [
    { id: 401, title: '晨跑vs夜跑：哪种更适合你的生活节奏？', excerpt: '从生物钟、空气质量到安全性，全方位对比早晚跑步的利与弊，帮你找到最适合的跑步时间。', author: '跑者阿飞', authorAvatar: 'https://readdy.ai/api/search-image?width=100&height=100&seq=avatar-04&orientation=squarish&query=Cute%20cartoon%20runner%20avatar%20with%20warm%20amber%20tones%20flat%20illustration%20style', readTime: 9, likes: 1980, date: '2026-08-05', imageUrl: 'https://readdy.ai/api/search-image?query=Peaceful%20park%20running%20path%20at%20sunrise%20with%20golden%20morning%20light%20through%20trees&width=600&height=400&seq=article-yundong-401&orientation=landscape', isHot: false },
    { id: 402, title: '居家健身终极指南：无器械也能练出好身材', excerpt: '不想去健身房？没关系！分享一套完整的居家徒手训练方案，每天30分钟，效果不输健身房。', author: '健身狂人', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20fitness%20avatar%20with%20warm%20coral%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-14&orientation=squarish', readTime: 11, likes: 4320, date: '2026-08-02', imageUrl: 'https://readdy.ai/api/search-image?query=Home%20workout%20space%20with%20yoga%20mat%20and%20dumbbells%20in%20warm%20natural%20morning%20light&width=600&height=400&seq=article-yundong-402&orientation=landscape', isHot: false },
    { id: 403, title: '瑜伽初学者必知：12个基础体式详解', excerpt: '瑜伽不仅是一种运动，更是一种生活方式。从最基础的体式开始，循序渐进地进入瑜伽的美妙世界。', author: '瑜伽教练Lily', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20yoga%20avatar%20with%20warm%20teal%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-15&orientation=squarish', readTime: 13, likes: 2870, date: '2026-07-28', imageUrl: 'https://readdy.ai/api/search-image?query=Peaceful%20yoga%20studio%20with%20warm%20morning%20light%20and%20minimal%20wooden%20floor&width=600&height=400&seq=article-yundong-403&orientation=landscape', isHot: false },
  ],
  yuedu: [
    { id: 501, title: '2026年必读书单：这12本书改变了我的人生观', excerpt: '从文学经典到社科新知，精选12本年度最佳读物。每本书都值得你花时间细细品读，收获远超想象。', author: '书虫小姐', authorAvatar: 'https://readdy.ai/api/search-image?width=100&height=100&seq=avatar-05&orientation=squarish&query=Cute%20cartoon%20bookworm%20avatar%20with%20warm%20teal%20tones%20flat%20illustration%20style', readTime: 15, likes: 2760, date: '2026-08-04', imageUrl: 'https://readdy.ai/api/search-image?query=Stack%20of%20beautiful%20books%20on%20cozy%20wooden%20desk%20with%20warm%20reading%20lamp&width=600&height=400&seq=article-yuedu-501&orientation=landscape', isHot: false },
    { id: 502, title: '如何培养每日写作习惯：从0到1000字的进阶之路', excerpt: '写作是最好的思考和表达方式。分享如何从每天写100字开始，逐步培养出稳定的写作习惯。', author: '笔耕不辍', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20writer%20avatar%20with%20warm%20amber%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-16&orientation=squarish', readTime: 10, likes: 1890, date: '2026-07-31', imageUrl: 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20fountain%20pen%20on%20warm%20wooden%20desk%20with%20soft%20natural%20light&width=600&height=400&seq=article-yuedu-502&orientation=landscape', isHot: false },
    { id: 503, title: '经典文学重读：为什么成年后读《活着》感触更深', excerpt: '有些书值得在不同年龄重读。成年后重读余华的《活着》，发现书中蕴含的人生哲理远超少年时的理解。', author: '文学评论家', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20scholar%20avatar%20with%20warm%20coral%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-17&orientation=squarish', readTime: 12, likes: 2340, date: '2026-07-25', imageUrl: 'https://readdy.ai/api/search-image?query=Old%20hardcover%20book%20open%20on%20wooden%20table%20with%20warm%20vintage%20lighting%20and%20reading%20glasses&width=600&height=400&seq=article-yuedu-503&orientation=landscape', isHot: false },
  ],
  youxi: [
    { id: 601, title: '从青铜到王者：新赛季最全面的英雄攻略合集', excerpt: '最新版本强势英雄深度解析，出装、铭文、打法一网打尽，助你在排位赛中快速上分！', author: '电竞老司机', authorAvatar: 'https://readdy.ai/api/search-image?width=100&height=100&seq=avatar-06&orientation=squarish&query=Cute%20cartoon%20gamer%20avatar%20with%20warm%20coral%20tones%20flat%20illustration%20style', readTime: 18, likes: 6230, date: '2026-08-03', imageUrl: 'https://readdy.ai/api/search-image?query=Gaming%20setup%20with%20RGB%20keyboard%20and%20mouse%20on%20dark%20desk%20with%20warm%20ambient%20lighting&width=600&height=400&seq=article-youxi-601&orientation=landscape', isHot: true },
    { id: 602, title: '独立游戏推荐：10款让人眼前一亮的精品小众游戏', excerpt: '玩腻了3A大作？这些独立游戏虽然体量不大，但创意十足、玩法独特，每一款都值得花时间体验。', author: '独立游戏控', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20pixel%20avatar%20with%20warm%20teal%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-18&orientation=squarish', readTime: 12, likes: 3450, date: '2026-07-29', imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20gaming%20corner%20with%20handheld%20console%20and%20warm%20ambient%20lighting%20on%20wooden%20desk&width=600&height=400&seq=article-youxi-602&orientation=landscape', isHot: false },
    { id: 603, title: '电竞选手的日常：职业玩家一天是怎样度过的', excerpt: '探秘职业电竞选手的真实生活，从早上的体能训练到晚上的战术复盘，比你想象的辛苦得多。', author: '电竞记者', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20journalist%20avatar%20with%20warm%20amber%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-19&orientation=squarish', readTime: 15, likes: 5120, date: '2026-07-22', imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20esports%20training%20room%20with%20multiple%20monitors%20and%20warm%20ambient%20lighting&width=600&height=400&seq=article-youxi-603&orientation=landscape', isHot: false },
  ],
  lvxing: [
    { id: 701, title: '独自旅行完全指南：一个人也能玩得尽兴', excerpt: '独自旅行是一种特别的体验，自由自在、随心所欲。分享安全出行、省钱住宿和深度游玩的全套攻略。', author: '背包客阿杰', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20backpacker%20avatar%20with%20warm%20teal%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-20&orientation=squarish', readTime: 14, likes: 2780, date: '2026-08-01', imageUrl: 'https://readdy.ai/api/search-image?query=Solo%20traveler%20with%20backpack%20on%20scenic%20mountain%20trail%20with%20warm%20golden%20hour%20light&width=600&height=400&seq=article-lvxing-701&orientation=landscape', isHot: false },
    { id: 702, title: '小众旅行地推荐：避开人潮的5个秘境', excerpt: '厌倦了人山人海的热门景点？发现几个鲜为人知的绝美旅行地，风景不输网红打卡点，人少景美体验佳。', author: '旅行猎人', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20explorer%20avatar%20with%20warm%20coral%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-21&orientation=squarish', readTime: 11, likes: 3560, date: '2026-07-28', imageUrl: 'https://readdy.ai/api/search-image?query=Hidden%20waterfall%20in%20lush%20green%20forest%20with%20warm%20sunlight%20filtering%20through%20trees&width=600&height=400&seq=article-lvxing-702&orientation=landscape', isHot: false },
  ],
  yinyue: [
    { id: 801, title: '吉他自学之路：从零基础到弹唱只需要三个月', excerpt: '学会吉他其实没那么难！分享高效的自学方法和练习计划，三个月后你也能在朋友面前自信弹唱。', author: '六弦先生', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20guitarist%20avatar%20with%20warm%20amber%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-22&orientation=squarish', readTime: 13, likes: 4120, date: '2026-08-02', imageUrl: 'https://readdy.ai/api/search-image?query=Acoustic%20guitar%20on%20wooden%20stand%20with%20warm%20sunlight%20and%20music%20sheet%20nearby&width=600&height=400&seq=article-yinyue-801&orientation=landscape', isHot: false },
    { id: 802, title: '治愈系歌单：适合一个人的午后慢慢聆听', excerpt: '精选20首温暖治愈的中文歌曲，适合泡一杯茶、翻开一本书时作为背景音乐，让时光慢下来。', author: '音乐疗愈师', authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20music%20note%20avatar%20with%20warm%20teal%20tones%20flat%20illustration%20style&width=100&height=100&seq=avatar-23&orientation=squarish', readTime: 8, likes: 5340, date: '2026-07-30', imageUrl: 'https://readdy.ai/api/search-image?query=Vinyl%20record%20player%20on%20cozy%20wooden%20cabinet%20with%20warm%20afternoon%20light%20and%20houseplants&width=600&height=400&seq=article-yinyue-802&orientation=landscape', isHot: false },
  ],
};

export const articleContents: Record<number, {
  title: string;
  author: string;
  authorAvatar: string;
  date: string;
  category: string;
  categorySlug: string;
  readTime: number;
  likes: number;
  imageUrl: string;
  body: string;
  tags: string[];
}> = {
  1: {
    title: '零基础也能学会的手工编织入门指南',
    author: '巧手小鹿',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20deer%20avatar%20with%20warm%20orange%20tones%20flat%20illustration%20style%20simple%20and%20friendly&width=100&height=100&seq=avatar-01&orientation=squarish',
    date: '2026-08-08',
    category: '手工DIY',
    categorySlug: 'shougong',
    readTime: 8,
    likes: 2340,
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20colorful%20yarn%20and%20knitting%20needles%20on%20warm%20wooden%20table%20with%20gentle%20sunlight%2C%20cozy%20handmade%20craft%20atmosphere%2C%20warm%20neutral%20tones%2C%20lifestyle%20photography&width=1200&height=600&seq=article-hero-1&orientation=landscape',
    body: `编织是一种古老而温暖的手工艺，一根钩针、一团毛线，就能创造出无限可能。对于零基础的新手来说，编织入门其实比你想象的要简单得多。

## 第一步：选择合适的工具和材料

对于初学者，建议从粗毛线和对应型号的钩针开始。粗毛线编织速度快，容易看到成果，能给你带来满满的成就感。推荐选择5mm-6mm的钩针，搭配中粗羊毛线，手感舒适且不易分叉。

## 第二步：掌握基本针法

编织的基础针法只有几种：锁针、短针、中长针和长针。先花一两个小时练习锁针起针，当你的锁针变得均匀紧密时，就可以开始尝试短针了。

## 第三步：完成你的第一件作品

建议第一件作品选择简单的围巾。不需要加减针，只需要来回钩短针就能完成。选择自己喜欢的颜色，用大约200克毛线，就能钩出一条温暖实用的围巾。

手工编织的魅力在于，每一件作品都是独一无二的，都倾注了创作者的时间和心血。当你把亲手编织的围巾送给朋友时，那种满足感是无法用言语表达的。`,
    tags: ['手工编织', 'DIY入门', '新手教程', '钩针'],
  },
  2: {
    title: '手机摄影进阶：10个让你照片质感翻倍的小技巧',
    author: '光影捕手',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20camera%20avatar%20with%20warm%20teal%20tones%20flat%20illustration%20style%20simple%20and%20friendly&width=100&height=100&seq=avatar-02&orientation=squarish',
    date: '2026-08-07',
    category: '摄影艺术',
    categorySlug: 'sheying',
    readTime: 12,
    likes: 3150,
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20photography%20setup%20on%20minimal%20wooden%20desk%20with%20soft%20natural%20light%20and%20scattered%20photos%2C%20creative%20modern%20atmosphere%2C%20warm%20neutral%20tones&width=1200&height=600&seq=article-hero-2&orientation=landscape',
    body: `不需要昂贵的相机设备，你口袋里的手机就是一台强大的摄影工具。掌握以下10个技巧，让你的手机照片质感瞬间提升。

## 1. 清洁镜头

这听起来很简单，但很多人都会忽略。手机镜头经常被指纹和灰尘覆盖，拍照前用软布轻轻擦拭镜头，照片清晰度立竿见影。

## 2. 善用网格线

打开手机相机的网格线功能，利用三分法则构图。将主体放在网格线的交叉点上，照片会更有视觉吸引力。

## 3. 寻找自然光

自然光是最好的灯光师。尽量在窗户旁边或户外拍摄，避免使用闪光灯。侧光能营造立体感，逆光则能拍出唯美的剪影效果。

## 4. 保持稳定

手持拍摄时，将手肘贴近身体，或借助墙壁、桌面等固定物支撑。拍夜景或长曝光时，一个小型三脚架是必备神器。

## 5. 学会后期处理

后期不是造假，而是还原你眼中看到的美丽。推荐使用手机版Lightroom或醒图，调整曝光、对比度和色温，让照片更接近你想要的风格。

摄影的本质是表达，技术只是手段。多拍多练，你一定能找到属于自己的摄影语言。`,
    tags: ['手机摄影', '摄影技巧', '构图', '后期处理'],
  },
  3: {
    title: '在家复刻网红甜品：零失败的提拉米苏做法',
    author: '厨房小当家',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20chef%20hat%20avatar%20with%20warm%20coral%20tones%20flat%20illustration%20style%20simple%20and%20friendly&width=100&height=100&seq=avatar-03&orientation=squarish',
    date: '2026-08-06',
    category: '美食烹饪',
    categorySlug: 'meishi',
    readTime: 10,
    likes: 4890,
    imageUrl: 'https://readdy.ai/api/search-image?query=Homemade%20tiramisu%20in%20elegant%20glass%20dish%20with%20cocoa%20powder%20dusting%20on%20rustic%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20cozy%20cooking%20atmosphere&width=1200&height=600&seq=article-hero-3&orientation=landscape',
    body: `提拉米苏，这个风靡全球的意大利经典甜品，其实做法比你想象的简单太多！不需要烤箱，不需要打蛋器，只要几种常见的食材就能完成。

## 所需材料

- 马斯卡彭芝士 250g
- 淡奶油 150ml
- 细砂糖 50g
- 蛋黄 3个
- 手指饼干 约20根
- 浓缩咖啡 200ml（放凉）
- 无糖可可粉 适量

## 制作步骤

### 1. 制作奶酪糊
将蛋黄和细砂糖隔水加热搅拌至浓稠发白，离火后加入马斯卡彭芝士搅拌至顺滑。淡奶油打至6分发（有纹路但还流动），与奶酪糊混合均匀。

### 2. 组装
手指饼干快速蘸取浓缩咖啡（不要泡太久），铺一层在容器底部，然后铺一层奶酪糊，重复这个步骤，最上面一层是奶酪糊。

### 3. 冷藏定型
放入冰箱冷藏至少4小时，最好过夜。吃之前撒上厚厚一层可可粉，用勺子挖着吃，入口即化！`,
    tags: ['提拉米苏', '烘焙', '甜品', '新手食谱'],
  },
  4: {
    title: '晨跑vs夜跑：哪种更适合你的生活节奏？',
    author: '跑者阿飞',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20runner%20avatar%20with%20warm%20amber%20tones%20flat%20illustration%20style%20simple%20and%20friendly&width=100&height=100&seq=avatar-04&orientation=squarish',
    date: '2026-08-05',
    category: '运动健身',
    categorySlug: 'yundong',
    readTime: 9,
    likes: 1980,
    imageUrl: 'https://readdy.ai/api/search-image?query=Peaceful%20park%20running%20path%20at%20sunrise%20with%20golden%20morning%20light%20through%20trees%2C%20fitness%20lifestyle%20scene%2C%20warm%20natural%20atmosphere&width=1200&height=600&seq=article-hero-4&orientation=landscape',
    body: `很多跑者都会纠结一个问题：到底是早上跑步好，还是晚上跑步好？其实没有绝对的答案，关键是要找到最适合你生活节奏和身体状况的时间。

## 晨跑的优势

早晨的空气清新，行人车辆较少，是享受宁静跑步的最佳时刻。晨跑还能帮助你在一天开始前就完成运动任务，带来满满的成就感。此外，早晨运动能提高新陈代谢，让你一整天都精力充沛。

## 晨跑的注意事项

早晨刚起床时，身体还处于半休眠状态，关节和肌肉比较僵硬。一定要做好充分的热身，从慢走到慢跑，循序渐进。另外，空腹跑步前可以喝一杯温水，吃半根香蕉补充能量。

## 夜跑的魅力

晚上跑步是释放一天压力的好方式。工作学习了一天，跑上几公里，把所有的疲惫和烦恼都甩在身后。夜跑后洗个热水澡，睡眠质量也会显著提升。

## 夜跑的安全问题

夜跑一定要注意安全！选择灯光充足、人流量适中的路线，穿着反光装备，最好结伴而行。女性跑者更要提高安全意识。

## 结论

无论是晨跑还是夜跑，坚持最重要。建议你两种都尝试一下，找到让自己最舒服、最能坚持的时间段。跑步的本质是与自己对话，享受这个过程才是最重要的。`,
    tags: ['跑步', '晨跑', '夜跑', '运动健康'],
  },
};

export const aboutData = {
  brand: {
    title: '关于撸撸社',
    intro: '撸撸社成立于2023年，是一个专注于兴趣爱好交流的社区平台。我们相信，每个人心中都有一份热爱，而这份热爱值得被看见、被分享、被尊重。',
    mission: '我们的使命是构建一个温暖、包容、高质量的社区空间，让每一个人的兴趣爱好都能在这里找到归属，让同好之间的连接变得更加简单自然。',
    vision: '我们希望通过不断优化的产品体验和社区氛围，成为中国最受欢迎的兴趣爱好交流平台，让「上撸撸社，找到同好」成为每一个兴趣爱好者的自然选择。',
    values: [
      { title: '真诚开放', desc: '我们鼓励每一位社区成员真诚地表达自己，分享真实的热爱和经历。' },
      { title: '互相尊重', desc: '我们珍视每一种兴趣爱好，尊重每一个热爱生活的人，营造友善的交流氛围。' },
      { title: '持续成长', desc: '我们相信分享就是最好的学习方式，在交流中共同进步、共同成长。' },
      { title: '创造价值', desc: '我们致力于让每一篇内容都充满价值，让每一位社区成员都能有所收获。' },
    ],
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20community%20gathering%20space%20with%20people%20sharing%20hobbies%20on%20wooden%20table%2C%20soft%20natural%20light%2C%20friendly%20atmosphere%2C%20creative%20lifestyle%20photography&width=600&height=400&seq=about-brand&orientation=landscape',
  },
  reputation: [
    { name: '小明', role: '手工爱好者', content: '在撸撸社认识了很多志同道合的朋友，大家一起交流手工心得，互相鼓励，我的编织技术进步飞快！', rating: 5, avatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20craft%20lover%20avatar%20warm%20orange%20tones%20flat%20illustration%20style&width=80&height=80&seq=user-r1&orientation=squarish' },
    { name: '阿杰', role: '摄影达人', content: '这个平台让我找到了组织！以前总觉得自己拍的照片没人欣赏，现在每次发帖都能收到很多用心的反馈。', rating: 5, avatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20photographer%20avatar%20warm%20teal%20tones%20flat%20illustration%20style&width=80&height=80&seq=user-r2&orientation=squarish' },
    { name: '小美', role: '美食博主', content: '撸撸社的社区氛围真的太棒了，大家都特别友善。分享的菜谱总有人复刻并给我反馈，超级有成就感！', rating: 5, avatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20food%20blogger%20avatar%20warm%20coral%20tones%20flat%20illustration%20style&width=80&height=80&seq=user-r3&orientation=squarish' },
    { name: '大壮', role: '健身爱好者', content: '在这里找到了很多同样喜欢跑步的朋友，我们还组织了线下约跑活动，撸撸社让我的生活变得更丰富了。', rating: 5, avatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20fitness%20lover%20avatar%20warm%20amber%20tones%20flat%20illustration%20style&width=80&height=80&seq=user-r4&orientation=squarish' },
    { name: '老张', role: '书友', content: '作为一个爱读书的人，撸撸社的书评区是我每天的必逛之处。认识了很多阅读品味相似的朋友，读书变得更有趣了。', rating: 5, avatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20book%20lover%20avatar%20warm%20green%20tones%20flat%20illustration%20style&width=80&height=80&seq=user-r5&orientation=squarish' },
    { name: '游戏少年', role: '电竞玩家', content: '撸撸社的游戏区干货超多！从攻略到赛事分析，每次逛都有收获。认识了一群一起开黑的队友，上分都更快乐了。', rating: 5, avatar: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20gamer%20avatar%20warm%20orange%20tones%20flat%20illustration%20style&width=80&height=80&seq=user-r6&orientation=squarish' },
  ],
  contact: {
    email: 'hello@lulushe.com',
    wechat: 'lulushe_official',
    weibo: '@撸撸社官方',
    address: '浙江省杭州市余杭区未来科技城',
    hours: '周一至周五 9:00 - 18:00',
  },
  milestones: [
    { year: '2023年3月', event: '撸撸社正式上线，首批1000名种子用户入驻' },
    { year: '2023年9月', event: '注册用户突破10万，上线社区互动功能' },
    { year: '2024年1月', event: '社区文章总数突破1万篇，涵盖8大兴趣分类' },
    { year: '2024年6月', event: '注册用户突破50万，上线积分体系和等级系统' },
    { year: '2025年1月', event: '用户数突破100万，成为中文兴趣社区领域的领先平台' },
    { year: '2026年3月', event: '注册用户突破128万，日均活跃用户超8.6万' },
  ],
};

export const faqData = [
  {
    question: '撸撸社是什么？',
    answer: '撸撸社是一个专注于兴趣爱好交流的社区平台。无论你喜欢手工、摄影、美食、运动、阅读、游戏还是旅行，都能在这里找到志同道合的朋友，分享你的热爱和故事。我们致力于打造一个温暖、友善、高质量的兴趣社区。',
  },
  {
    question: '如何注册成为撸撸社会员？',
    answer: '注册非常简单！点击页面右上角的"注册"按钮，使用手机号或邮箱即可快速注册。注册完成后，你可以完善个人资料，选择你感兴趣的分类，系统会为你推荐相关的内容和用户。',
  },
  {
    question: '撸撸社是免费的吗？',
    answer: '是的，撸撸社的基础功能完全免费！你可以自由浏览内容、发布文章、参与讨论。我们也提供会员增值服务，解锁更多高级功能，如专属标识、去广告体验、优先参与线下活动等。',
  },
  {
    question: '如何在撸撸社发布内容？',
    answer: '成为注册会员后，点击页面右上角的"发布"按钮，选择文章、图片或视频类型，就可以开始创作了。我们支持富文本编辑，你可以插入图片、视频等多媒体内容，让文章更加生动丰富。',
  },
  {
    question: '如何找到我感兴趣的内容和用户？',
    answer: '你可以通过首页的分类导航浏览不同兴趣领域的内容，也可以使用搜索功能查找关键词相关的内容和用户。关注你喜欢的作者后，他们的最新动态会出现在你的首页信息流中。',
  },
  {
    question: '撸撸社支持哪些兴趣爱好分类？',
    answer: '我们目前覆盖手工DIY、摄影艺术、美食烹饪、运动健身、阅读写作、游戏电竞、旅行探索、音乐之声等八大核心分类，每个分类下都有丰富的细分话题。如果你有新的分类建议，也欢迎随时向我们反馈！',
  },
];

export const timelineData = [
  { year: '2023', title: '创立启航', desc: '撸撸社正式成立，以"发现热爱，连接同好"为使命开启旅程', icon: 'ri-rocket-line' },
  { year: '2023', title: '首破10万', desc: '注册用户突破10万大关，社区生态初步形成', icon: 'ri-user-heart-line' },
  { year: '2024', title: '快速成长', desc: '文章总数突破1万篇，逐步完善社区功能和体验', icon: 'ri-line-chart-line' },
  { year: '2025', title: '百万里程碑', desc: '用户数突破100万，成为中国兴趣社区领先平台', icon: 'ri-star-line' },
  { year: '2026', title: '持续进化', desc: '注册用户突破128万，不断优化体验，拓展新领域', icon: 'ri-shining-line' },
];